// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__0C3C3","form_main":"ContactForm_form_main__pYyY4"};